import { render, staticRenderFns } from "./zhihuianquan.vue?vue&type=template&id=e15ac206&scoped=true&"
import script from "./zhihuianquan.vue?vue&type=script&lang=js&"
export * from "./zhihuianquan.vue?vue&type=script&lang=js&"
import style0 from "./zhihuianquan.vue?vue&type=style&index=0&id=e15ac206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15ac206",
  null
  
)

export default component.exports